import { render, staticRenderFns } from "./Auth_Recover.vue?vue&type=template&id=5c9cc5f0&"
import script from "./Auth_Recover.vue?vue&type=script&lang=js&"
export * from "./Auth_Recover.vue?vue&type=script&lang=js&"
import style0 from "./Auth_Recover.vue?vue&type=style&index=0&id=5c9cc5f0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports